import { CalendarManager, IPOs } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { injectLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchSpac = (session: Session, params = {}, injectTickersLogos = true, pageSize = 100): Promise<IPOs[]> => {
  const query = { ...params, ipoType: 'SPAC' as const, pageSize };
  return session
    .getManager(CalendarManager)
    .getCalendarData('ipos', query)
    .then(res => {
      if (res.ok && res.ok.length) {
        const items = res.ok.filter(item => item.ipo_type === 'SPAC').reverse();
        return injectTickersLogos ? injectLogos(items) : items;
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('SPAC', error);
      return [];
    });
};

export { fetchSpac };
